// src/services/archiveApi.js
// Lig ve sezon arşivi.
//
// Arşiv yalnızca seçilebilirliği kapatır: arşivlenen lig/sezon site geneli
// filtrelerden, maç oluşturma ekranından ve içerik havuzundan düşer.
// İstatistikler etkilenmez — arşivdeki lig/sezon sayfaları normal çalışır.
import api, { apiGet } from "../api/api";

const seg = (value) => encodeURIComponent(String(value));

/** Kayıt arşivde mi? (0/1, "true"/"false", null toleranslı) */
export const isArchivedEntity = (entity) => {
  if (!entity) return false;
  const raw = entity.is_archived ?? entity.isArchived ?? entity.archived;
  if (raw === undefined || raw === null) return false;
  if (typeof raw === "string") {
    const normalized = raw.trim().toLocaleLowerCase("tr-TR");
    return ["1", "true", "evet", "yes"].includes(normalized);
  }
  return Boolean(raw);
};

/** Seçici etiketlerinde arşiv kaydını ayırt etmek için. */
export const withArchiveLabel = (label, archived) =>
  archived ? `${label} (Arşiv)` : label;

export const archiveApi = {
  // Footer arşiv alanı ve /arsiv sayfası bu uçtan beslenir.
  tree: async (params = {}, config = {}) =>
    (await apiGet("/api/meta/archive", { ...config, params })).data,

  // Ligi arşive alır/çıkarır. Lige ait TÜM sezonlar da aynı duruma geçer.
  setLeagueArchived: async (leagueId, archived) =>
    (await api.patch(`/ligler/${seg(leagueId)}/archive`, { archived })).data,

  // Yalnızca ilgili sezonu arşive alır/çıkarır.
  setSeasonArchived: async (seasonId, archived) =>
    (await api.patch(`/sezonlar/${seg(seasonId)}/archive`, { archived })).data,
};

export default archiveApi;
